type HeaderProps = {
  headerTitle: string;
  subTitle: string;
  datePicker?: boolean;
  leftIcon?: React.ReactNode;
  label?: string;
  searchBar?: boolean;
};
export default function UnAuthHeader({ headerTitle, subTitle }: HeaderProps) {
  return (
    <div className="py-2 sm:py-4 mb-2 sm:mb-4 !w-full">
      <div className="flex flex-col !items-center !justify-center">
        <h2 className="text-app-dark !font-inter font-semibold text-2xl sm:text-3xl pb-1 text-center px-2">
          {headerTitle}
        </h2>
        <p className="text-app-light !text-center flex items-center gap-2 !font-inter font-medium text-xs sm:text-sm px-2">
          {subTitle}
        </p>
      </div>
    </div>
  );
}
